import { render, staticRenderFns } from "./CustomerInvoice.vue?vue&type=template&id=0d5ad3be"
import script from "./CustomerInvoice.vue?vue&type=script&lang=js"
export * from "./CustomerInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports